// external imports
import React from 'react'
import Helmet from 'react-helmet'
import { FlexColumn } from 'quark-web'
import { graphql } from 'react-relay'
// local imports
import { QueryRenderer } from '~/components'
import DistributorMap from './DistributorMap'
import DistributorList from './DistributorList'

const Distributors = () => (
    <React.Fragment>
        <Helmet title="Distributors" />
        <QueryRenderer
            query={graphql`
                query DistributorsQuery {
                    allDistributors {
                        edges {
                            node {
                                id
                                name
                                addressLine1
                                addressLine2
                                cityStateLine
                                longitude
                                latitude
                                region {
                                    name
                                }
                            }
                        }
                    }
                }
            `}
            render={data => {
                // get the flat list of distributors
                const distributors = !data ? null : data.allDistributors

                // render the sections of this view
                return (
                    <FlexColumn style={{ width: 700 }} alignSelf="center">
                        <DistributorMap distributors={distributors} />
                        <DistributorList distributors={distributors} />
                    </FlexColumn>
                )
            }}
        />
    </React.Fragment>
)

export default Distributors



// WEBPACK FOOTER //
// ./src/views/Distributors/index.js